import classNames from 'classnames';
import { Card } from 'antd';
import { KeyValue } from 'components/common/KeyValue';

import styles from './index.module.scss';

export interface DeliveryInfoProps {
  order: Order.Item;
  className: string;
}

export const DeliveryInfo = ({ order, className }: DeliveryInfoProps) => {
  const { deliveryInfo } = order;

  return (
    <Card
      title='Delivery info'
      className={classNames(styles.card, className)}
    >
      <KeyValue title='Name' value={deliveryInfo.name} />
      <KeyValue title='Lastname' value={deliveryInfo.lastname} />
      <KeyValue title='Phone' value={deliveryInfo.phone} />
      <KeyValue title='City' value={deliveryInfo.city} />
      <KeyValue title='City ID' value={deliveryInfo.cityId} />
      <KeyValue title='Call before delivery' value={!deliveryInfo.call ? 'Yes' : 'No'} />
      {deliveryInfo.cost != null && (
        <KeyValue title='Delivery cost' value={`$${(deliveryInfo.cost / 100).toString()}`} />
      )}
      <KeyValue title='Warehouse type' value={deliveryInfo.warehouse.type} />
      <KeyValue title='Warehouse ID' value={deliveryInfo.warehouse.id.toString()} />
    </Card>
  );
};
